// components/Layout.tsx
"use client"

import React from 'react';
import { Navigation } from './Navigation'
import { Footer } from '@/components/Footer'
import ParticleBackground from './ParticleBackground';
import { LoadingIndicator } from './LoadingIndicator';

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-background font-sans antialiased relative">
      {/* 添加页面加载指示器 */}
      <LoadingIndicator />
      
      {/* 添加星空背景，z-index设为2 */}
      <div className="absolute inset-0 z-[2]">
        <ParticleBackground />
      </div>
      
      {/* 内容包装器 */}
      <div className="relative z-[3]">
        <Navigation />
        <main>
          {children}
        </main>
        <Footer />
      </div>
    </div>
  )
}

{/* <div className="min-h-screen bg-background font-sans antialiased">
<Navigation/>
<main classname="flex-1">{children}</main>
<Footer/>
</div> */}